import { render, staticRenderFns } from "./ForestTreesPage.vue?vue&type=template&id=2d6c08bb&scoped=true&"
import script from "./ForestTreesPage.vue?vue&type=script&lang=ts&"
export * from "./ForestTreesPage.vue?vue&type=script&lang=ts&"
import style0 from "./ForestTreesPage.vue?vue&type=style&index=0&id=2d6c08bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c08bb",
  null
  
)

export default component.exports